import { Button } from 'components/shared/Button'
import { useAuth } from 'contexts/auth'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = {
  xs?: boolean
  activeLottery?: Lottery
}

export const EntryButton: FC<Props> = ({ xs, activeLottery }) => {
  const { isAuthenticated, setIsSignInOpened, setSignInNotification } =
    useAuth()
  const { t } = useTranslation()

  const handleSignIn = async () => {
    setIsSignInOpened(true)
    setSignInNotification(t('エントリーするには、ログインが必要です。'))
  }

  if (!activeLottery) return <></>

  if (!isAuthenticated) {
    return (
      <Button
        style={{
          borderRadius: 40,
          height: 48,
          width: xs ? '100%' : 262,
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          padding: '16px 24px',
        }}
        type="primary"
        onClick={handleSignIn}
      >
        {t('エントリーする')}
      </Button>
    )
  }

  if (!activeLottery.satisfies_rank_requirements) {
    return (
      <Button
        style={{
          borderRadius: 40,
          height: 48,
          width: xs ? '100%' : 262,
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          padding: '16px 24px',
        }}
        type="primary"
        disabled
      >
        {t('エントリーする')}
      </Button>
    )
  }

  return (
    <Link href={`/lotteries/${activeLottery.id}`}>
      <a>
        <Button
          style={{
            borderRadius: 40,
            height: 48,
            width: xs ? '100%' : 262,
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 24px',
          }}
          type="primary"
        >
          {t('エントリーする')}
        </Button>
      </a>
    </Link>
  )
}
